import PropTypes from 'prop-types';
import { i18nMark } from 'lingui-react';
import buildEnum from 'utils/buildEnum';
import { withState } from 'recompose';

export const sortDirections = buildEnum(['desc', 'asc']);

export const sortDirectionsLabels = {
  [sortDirections.desc]: i18nMark('Newest First'),
  [sortDirections.asc]: i18nMark('Oldest First'),
};

export const sortDirectionPropType = PropTypes.oneOf(
  Object.values(sortDirections),
);

export const withSortDirection = (order = sortDirections.desc) =>
  withState('sortDirection', 'onSelectDirection', order);



// WEBPACK FOOTER //
// ./src/components/FieldUpdates/withSortDirection.js